export default __webpack_public_path__ + "static/media/background.8c785f95.jpg";